import React from 'react';
import { FadeIn } from './ui/FadeIn';
const cases = ['Property Developers', 'Estate Surveying & Valuation Firms', 'Real Estate Agents', 'Property & Facility Managers', 'Banks & Financial Institutions', 'Property Owners & Landlords', 'Investors & Development Stakeholders'];
export function UseCases() {
  return <section className="py-24 bg-zinc-950 overflow-hidden" data-id="element-215" data-mp="31etviokn6g5i">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-216" data-mp="2wh1vf79ufnq8">
        <FadeIn data-id="element-217" data-mp="2wefo98qv7a8j">
          <h2 className="text-sm font-medium tracking-widest uppercase text-zinc-500 mb-12" data-id="element-218" data-mp="2rhfiz01uabih">
            Who We Serve
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-219" data-mp="2mj47ylzt5uyo">
          {cases.map((item, index) => <div key={index} className="px-6 py-3 rounded-full glass-panel text-zinc-300 text-sm md:text-base hover:text-white hover:bg-white/10 transition-colors cursor-default" data-id="element-220" data-mp="krhqbb1t3cev" data-mpi={index}>
              {item}
            </div>)}
        </FadeIn>
      </div>
    </section>;
}